import React from 'react'

import InvoiceProvider from '../../../providers/InvoiceProvider'
import PaymentProvider from '../../../providers/PaymentProvider'
import SubscriptionProvider from '../../../providers/SubscriptionProvider'

import LoadingSpinner from '../../../components/atoms/LoadingSpinner'
import SettingsPage from '../SettingsPage'
import SettingsSections from './SettingsSections'

import combineComponents from '../../../utilities/combineComponents'
import { useEnvironment } from '../../../providers/EnvironmentProvider'
import useStyles from './styles'

const Wrapper = combineComponents(
  PaymentProvider,
  SubscriptionProvider,
  InvoiceProvider
)

const SubscriptionSettings = () => {
  const { env, loaded } = useEnvironment()

  const classes = useStyles()

  return (
    <SettingsPage title={`Subscription & Billing`}>
      {!loaded ? (
        <div className={classes.loading}>
          <LoadingSpinner />
        </div>
      ) : !env.billing ? (
        <div className={classes.noBilling}>
          No billing account has been set up for this environment
        </div>
      ) : (
        <Wrapper>
          <SettingsSections />
        </Wrapper>
      )}
    </SettingsPage>
  )
}

export default SubscriptionSettings
